module.exports = __webpack_public_path__ + "img/location-1-ended.2c080c51.png";